import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapAriseFeeTemplateQueueDataFromServer } from "mappers";
import { feeTemplateService } from "services";
import { uiActions } from "store";
import { ErrorResponse, FeeTemplateQueueType } from "types";

const useAriseFeeTemplateQueueQuery = ({
	companyId,
}: {
	companyId: string;
}) => {
	const dispatch = useDispatch();

	return useQuery(
		[`arise-fee-template`, companyId],
		() =>
		feeTemplateService.ariseFeeTemplatesGet({companyId}),
		{
			select: (data: { [key: string]: any }): FeeTemplateQueueType[] =>
				data?.map(mapAriseFeeTemplateQueueDataFromServer),
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!companyId,
		},
	);
};
export default useAriseFeeTemplateQueueQuery;
